import { apiFetch } from './client';
import type { EffectivePlan, UserPermissions } from '@shared/types';
import type { SelfProfileUpdateInput } from '@shared/schemas';

export type MeResponse = {
  user: {
    id: string;
    email: string | null;
    phone: string | null;
    fullName: string | null;
    role: 'platform_owner' | 'business_admin' | 'business_user';
    businessId: string | null;
    lastSeenAt: number | null;
  };
  business: {
    id: string;
    name: string;
    plan: 'free' | 'pro';
    gstin: string | null;
    whatsappNumber: string | null;
    logoBlobUrl: string | null;
  } | null;
  plan: EffectivePlan;
  permissions: UserPermissions;
};

export function fetchMe(): Promise<MeResponse> {
  return apiFetch<MeResponse>('/api/me');
}

export type UpdateMyProfileResponse = {
  user: MeResponse['user'];
};

export function updateMyProfile(input: SelfProfileUpdateInput): Promise<UpdateMyProfileResponse> {
  return apiFetch<UpdateMyProfileResponse>('/api/me/profile', { method: 'PATCH', json: input });
}
